import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, Spinner } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { LockIcon, UnlockIcon } from '../../../Assets/images/svgs';
import './style.css';

const VehicleLockUnlockModal = ({ show, hide, isLocked, isLoading, vehicleRegNum = "", onLockUnlock, onSuccess }) => {
  const [currentState, setCurrentState] = useState("confirm");

  useEffect(() => {
    if (!isLoading && currentState === "waiting") {
      setCurrentState("success");
    }
  }, [currentState, isLoading]);

  const onLockUnlockWrapper = () => {
    if (typeof onLockUnlock !== "function") return;

    onLockUnlock();
    setCurrentState("waiting");
  };

  const onSuccessWrapper = () => {
    if (typeof onSuccess !== "function") return;
    hide();
    onSuccess();
  };

  const text = isLocked ? "Unlock" : "Lock";
  const textLowerCase = text.toLowerCase();

  const getConfirmState = () => {
    return (
      <>
        <ModalBody className="modal-body" textAlign={"center"}>
          <p className='confirm-msg'>Are you sure you want to {textLowerCase} the vehicle {vehicleRegNum}</p>
        </ModalBody>

        <ModalFooter className="modal-footer" display={"flex"} justifyContent={"center"} mt={"30"} >
          <div className='btn-group'>
            <Button onClick={hide} className='btn cancel-btn'>Cancel</Button>
            <Button onClick={onLockUnlockWrapper} className='btn'>{text}</Button>
          </div>
        </ModalFooter>
      </>
    )
  };

  const getWaitigState = () => {
    return (
      <>
        <ModalBody className="modal-body" textAlign={"center"}>
          {(isLoading) && <Spinner size={"lg"} />}
        </ModalBody>

        <ModalFooter className="modal-footer" display={"flex"} justifyContent={"center"} mt={"30"} >
          <div className='waiting-msg'>
            <p>Vehicle {vehicleRegNum} is getting {textLowerCase + "ed"}</p>
            <span>It might take upto 10 sec</span>
          </div>
        </ModalFooter>
      </>
    )
  };

  const getSuccessState = () => {
    return (
      <>
        <ModalBody className="modal-body" textAlign={"center"}>
          <div className='success-msg'>
            <div className={!isLocked ? "active-lock" : "active-unlock"} >
              {!isLocked ? <LockIcon /> : <UnlockIcon />}
            </div>
            <p>Vehicle {vehicleRegNum} is now {textLowerCase + "ed"}</p>
          </div>
        </ModalBody>

        <ModalFooter className="modal-footer" display={"flex"} justifyContent={"center"} mt={"30"} >
          <div>
            <Button onClick={onSuccessWrapper} className='btn'>Okay</Button>
          </div>
        </ModalFooter>
      </>
    )
  };

  const getState = (state) => {
    switch (state) {
      case "confirm":
        return getConfirmState();
      case "waiting":
        return getWaitigState();
      case "success":
        return getSuccessState();
      default:
    }
  };

  return (
    <Modal isOpen={show} onClose={() => hide(false)} isCentered size={"lg"} closeOnEsc={false} closeOnOverlayClick={false}>
      <ModalOverlay />

      <ModalContent className="modal-content vehicle-lock-unlock-modal">
        {getState(currentState)}
      </ModalContent>
    </Modal>
  )
};

export default VehicleLockUnlockModal;
